export default __webpack_public_path__ + "static/media/jm.818a3c55.svg";